import "./App.css";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import LandingPage from "./components/landing/LandingPage";
import CompanyPage from "./components/landing/CompanyPage";
import PropertySimulator from "./pages/PropertySimulator";

// Recruit Section Imports
import RecruitNavigation from "./components/layout/RecruitNavigation";
import RecruitFooter from "./components/layout/RecruitFooter";
import StickyMobileCTA from "./components/layout/StickyMobileCTA";
import TopPage from "./pages/TopPage";
import MessagePage from "./pages/MessagePage";
import AboutPage from "./pages/AboutPage";
import WorkPage from "./pages/WorkPage";
import CulturePage from "./pages/CulturePage";
import CareersPage from "./pages/CareersPage";
import HiringProcessPage from "./pages/HiringProcessPage";
import SummaryPage from "./pages/SummaryPage";
import ContactPage from "./pages/ContactPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";

// Recruit Layout wrapper component - separate nav/footer from main site
function RecruitLayout() {
  return (
    <div className="min-h-screen bg-acoe-bg font-body">
      <RecruitNavigation />
      <main className="pb-16 md:pb-0">
        <Outlet />
      </main>
      <RecruitFooter />
      <StickyMobileCTA />
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Main Site Routes */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/company" element={<CompanyPage />} />
          <Route path="/simulator" element={<PropertySimulator />} />
          
          {/* Hidden Recruit Section Routes - separate navigation */}
          <Route path="/recruit" element={<RecruitLayout />}>
            <Route index element={<TopPage />} />
            <Route path="message" element={<MessagePage />} />
            <Route path="about" element={<AboutPage />} />
            <Route path="work" element={<WorkPage />} />
            <Route path="culture" element={<CulturePage />} />
            <Route path="careers" element={<CareersPage />} />
            <Route path="process" element={<HiringProcessPage />} />
            <Route path="summary" element={<SummaryPage />} />
            <Route path="contact" element={<ContactPage />} />
            <Route path="contact/:type" element={<ContactPage />} />
            <Route path="privacy" element={<PrivacyPolicyPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
